/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef } from 'react';
import usePrevious from '@ally/use-previous';
import { getRowToExpand } from '../../utils';
const useDrawer = ({ tableInstance, row, drawer, }) => {
    var _a;
    const targetRef = useRef(null);
    const { state: { expanded }, toggleAllRowsExpanded, toggleRowExpanded, } = tableInstance;
    const prevExpanded = usePrevious(expanded);
    useEffect(() => {
        if (!(drawer === null || drawer === void 0 ? void 0 : drawer.allowMultipleOpen)) {
            const rowToExpand = getRowToExpand(expanded, prevExpanded);
            if (rowToExpand) {
                toggleAllRowsExpanded(false);
                toggleRowExpanded([rowToExpand]);
            }
        }
    });
    return Object.assign(Object.assign({}, (drawer || {})), { panelId: `mui-drawer-panel-${row.id}`, colCount: ((_a = drawer === null || drawer === void 0 ? void 0 : drawer.columns) === null || _a === void 0 ? void 0 : _a.length) || 0, isOpen: row.isExpanded, toggle: () => row.toggleRowExpanded(), targetRef });
};
export { useDrawer };
//# sourceMappingURL=useDrawer.js.map